let bc = null;
export default function start(onMsg) {
    console.log('start broadcast');
    bc = new BroadcastChannel('cess');
    if (onMsg) {
        bc.onmessage = function (e) {
            let data = e.data;
            if (typeof data == 'string') {
                try {
                    data = JSON.parse(data);
                    if (data.v) {
                        data = data.v;
                    }
                } catch (err) { }
            }
            console.log('onmessage', data);
            onMsg(data);
        };
    }
    bc.onmessageerror = function (e) {
        console.warn('broadcast onmessageerror');
    };
    return function (msg) {
        let json = { v: msg };
        console.log('send msg', msg);
        bc.postMessage(JSON.stringify(json));
    }
}
